// this redirect, takes in account if the redirect is to the same page, and if so it reloads the page
function bm_callbacks_apply_redirect(newLocation = ''){
    var params_to_leave = ['asset', 'category'];
    var params_to_return = [];
    try {
        var params = getUrlParams();
        for (var i = 0; i < params_to_leave.length; i++) {
            var param_name = params_to_leave[i];
            if (params.hasOwnProperty(param_name)) {
                params_to_return.push(param_name + '=' + encodeURIComponent(params[param_name]));
            }
        }
        if (params_to_return.length) {
            newLocation += '?' + params_to_return.join('&');
        }
    } catch (e) {}
    window.top.location.href = newLocation;
}

function bm_callbacks_get_redirects_link(page){
    var link = '' ;

    var urlPrefix = 'https://' + bm_callbacks_get_env_url_prefix() + 'www.' + bm_callbacks_get_site_domain() + '/' ;
    switch (page){
        case 'trade' :   link = urlPrefix + 'redirects/trade/' ; break ;
        case 'deposit': link = urlPrefix + 'redirects/my-account/deposit/' ; break ;
        case 'open-account': link =urlPrefix + 'redirects/open-account/' ; break ;
    }
    return link ;
}

function bm_callbacks_get_env_url_prefix(){
    var bm_env = window.bm_env || '';
    bm_env = bm_env.toLowerCase();
    if (bm_env == 'production') {
        bm_env = '';
    }
    return bm_env;
}

function bm_callbacks_get_site_domain(){
    var hostName = location.hostname.split(".") ;
    return hostName[hostName.length -2] + '.' + hostName[hostName.length -1] ;
}


/**
 * Takes url and find params
 * @returns array of key value
 */
function getUrlParams() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transferToArray(prmstr) : {};
}

/**
 * Parse url params into array
 * @param prmstr
 * @returns {{}}
 */
function transferToArray( prmstr ) {
    var params = {};
    var prmarr = prmstr.split("&");
    for ( var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}